import { createListenerMiddleware } from '@reduxjs/toolkit'
import { addFantasyRankingsListeners } from '../listeners/fantasy-rankings'
import type { AppStartListening as FantasyAppStartListening } from '../store.fantasy'
import type { AppStartListening as CommonAppStartListening } from '../store'
import { addFantasyLdaSpecificListeners } from '../listeners/fantasy-lda-specific'
import { addFantasyMDSSpecificListeners } from '../listeners/fantasy-mds-specific'
import { addFantasyDraftRoomSpecificListeners } from '../listeners/fantasy-draft-room'
import { addFantasyInSeasonSpecificListeners } from '../listeners/fantasy-in-season/in-season-specific-listeners'
import { addFantasyStandaloneRankingsListeners } from '../listeners/fantasy-standalone-rankings-listener'
import { addFantasyMatchupsListeners } from '../listeners/fantasy-matchups'

export const listenerMiddleware = createListenerMiddleware()

const startAppListening = listenerMiddleware.startListening as FantasyAppStartListening

addFantasyRankingsListeners(startAppListening)
addFantasyLdaSpecificListeners(startAppListening)
addFantasyMDSSpecificListeners(startAppListening)
addFantasyDraftRoomSpecificListeners(startAppListening)
addFantasyInSeasonSpecificListeners(listenerMiddleware.startListening as CommonAppStartListening)
addFantasyStandaloneRankingsListeners(startAppListening)
addFantasyMatchupsListeners(startAppListening)
